import _ from 'lodash';
import { flowTypes } from '@/common/service/page-config';
import Flow from '@/flows/flow';
import { VIEWS } from '@/common/constants.js';
import { buildAccountBaseService } from '@/common/service/base-paid';
import { loadSelectByPersist } from '@/common/service/plan-data-mapper';
import PageLoader from '@/common/service/flow/page-loader';
import { loadDefaultPlansByPartnerReferral4MixBuy } from '@/views/config/partner-refer/helper/preload';
import { loadDefaultPlansByPreloadCoupon4MixBuy } from '@/views/config/coupon/helper/preload';
import store from '@/store';
import { updatePlansCheckout, UpdateTypes } from '@/common/service/checkout-utils';
import { showCouponTermsMessage } from '@/views/config/coupon/helper/utils';
import { getPartnershipParams } from '@/views/config/partner-refer/helper/params';

const resolveView = () => VIEWS.COMPOUND;

const initShoppingCart = async (state) => {
  const { persist } = state;
  const { planMap, subscriptions, boughtPlans, freeTrialPlans, allPlanMap } = await buildAccountBaseService();

  const loader = new PageLoader(planMap);
  loader.decorate('loadByPersist', loadSelectByPersist(persist));
  loader.decorate('loadDefaultPlansByPreloadCoupon4MixBuy', loadDefaultPlansByPreloadCoupon4MixBuy(boughtPlans));
  loader.decorate('loadDefaultPlansByPartnerReferral4MixBuy', loadDefaultPlansByPartnerReferral4MixBuy(boughtPlans));
  const planList = await loader.dispatch();

  return {
    allPlanMap,
    boughtPlans,
    subscriptions,
    freeTrialPlans,
    planMapFlat: planList,
  };
};

const checkOutSubmit = (submitParams) => {
  const getters = store.getters;
  const mixBuyPlanType4FlowType = getters.mixBuyPlanType4FlowType;
  const getSelectedPlans = getters.getSelectedPlans;
  const boughtPlanWithPlanType = _.groupBy(getters.boughtPlans, 'type');

  const editPlanTypeList = _.get(mixBuyPlanType4FlowType, [flowTypes.edit], []);

  const oldPlanCodeMap = _.reduce(editPlanTypeList, (pre, planType) => {
    const planCode = _.get(boughtPlanWithPlanType, [planType, 0, 'plan_code'], '');

    return {
      ...pre,
      ...(planCode ? { [planType]: planCode } : {}),
    };
  }, {});

  // todo just consider single case (one by one)
  const planList = _.map(getSelectedPlans, (plan) => {
    const oldPlanCode = _.get(oldPlanCodeMap, [plan?.type]);

    return {
      quantity: plan.cartInfo?.selected_number,
      planCode: plan.plan_code,
      ...(oldPlanCode ? { oldPlanCode } : {}),
    };
  });

  const couponData = getters.orderDataPayload.coupon;
  const extensionUpdateData = getPartnershipParams();

  // todo need consider mix buy with coupon/partner cases
  return updatePlansCheckout(submitParams, planList, UpdateTypes.MIX_BUY_PARTNER, couponData, extensionUpdateData);
};

const preCheck = async () => {
  await showCouponTermsMessage(store.getters.tncMessage);
}

export default {
  [flowTypes.mixBuy]: class extends Flow {
    view() {
      return resolveView();
    }

    init() {
      return initShoppingCart(...arguments);
    }

    beforeSubmit() {
      return preCheck();
    }

    submit(submitParams) {
      return checkOutSubmit(submitParams);
    }
  },
};
